import { useEffect } from 'react';

import representativeByIdentityManager from '@gasbi/shared/common/utils/representativeByIdentityManager';
import { useAuth as useOIDCAuth } from 'react-oidc-context';

import { useLazyGetUserByIdQuery } from '@/features/auth/authApi';
import { useLazyGetRepresentativeByIdentityIdQuery } from '@/features/representatives/representativesApi';
import { Representative } from '@/features/representatives/types';

let flag = false;

const useAuth = () => {
  const oidc = useOIDCAuth();
  const { user: session, signoutRedirect } = oidc;

  const userId = session?.profile?.sub as any;

  const [fetch, { data, error }] = useLazyGetUserByIdQuery();
  const [fetchRepresentativeByIdentityId] =
    useLazyGetRepresentativeByIdentityIdQuery();

  useEffect(() => {
    (async () => {
      if (!flag && userId) {
        await fetch(userId);
        const account = await fetchRepresentativeByIdentityId(userId).unwrap();
        representativeByIdentityManager.setState(
          (account as Representative)?.id,
        );
        flag = true;
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  if (error) {
    signoutRedirect();
  }

  return {
    oidc,
    session,
    user: {
      ...data,
      fullName: [data?.lastName, data?.firstName, data?.middleName]
        .filter(Boolean)
        .join(' '),
    },
    logout: async () => {
      await signoutRedirect({
        state: window.location.pathname,
      });
    },
  };
};

export default useAuth;
